export const LoadingContainer = () => {
    return (
        <div>
            {'Loading.'}
        </div>
    );
}